import styled, { css } from 'styled-components';
import { colors } from '@alixpartners/ui-components';

export const Tab = styled.div`
	height: 64px;
	width: 320px;
	color: ${colors.grey8};
	background-color: ${({ isActive }) =>
		isActive ? colors.green0 : colors.transparent};
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 0 32px;
	text-decoration: none;

	&:hover {
		background-color: ${colors.green0};
	}

	${({ disabled }) =>
		disabled &&
		css`
			pointer-events: none;
			color: ${colors.grey5};
		`};
`;

export const Label = styled.div`
	font-weight: 500;
	font-size: 16px;
	line-height: 24px;
	letter-spacing: 0.3px;
`;
